import BankSelection from './BankSelection';
import Connecting from './Connecting';
import { useBankSession } from './useBankSession';

const BankSelectionStep = () => {
	const { bank, onBankSelect, onCountryChange } = useBankSession();

	if (!bank) {
		return <BankSelection onBankSelect={onBankSelect} onCountryChange={onCountryChange} />;
	}

	return <Connecting bank={bank} />;
};

export default BankSelectionStep;
